import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';
import { useParams } from "react-router-dom";


function Form() {

    const { id } = useParams();

    const endpointBackend = config.endpoints.backend;
    const path = '/core/applicationsinstances/';
    const paths = {
        endpointSave: endpointBackend+'core/applicationsinstances/save',
        endpointGetById: endpointBackend+'core/applicationsinstances/getById',
        endpointQrcode: config.endpoints.backend+'core/applicationsinstances/qrcode',
        urlGoBack: path+'list',
        pathView: path+'view'
    }

    const labels = {
        labelTitleAdd:  "Nova Instalação",
        labelTitleEdit: "Editar Instalação",
        labelTitleView: 'Visualizar Instalação'
    }
    
    const form = {
        validateOnChange: true,
        fields: [
            {
                name: 'application_id',
                type: 'select',
                label: 'Aplicação',
                options: [],
                optionsEndpoint:{
                    endpoint: endpointBackend+'core/applications/getall',
                    label: 'application_name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'instance_name',
                type: 'text',
                label: 'Instalação',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'phone',
                type: 'phone',
                label: 'Telefone',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'photo',
                type: 'fileS3',
                label: 'Foto/Logo',
                uploadPath: '/instance/photos/',
                extensionAccept: '.jpeg,.jpg,.png',
                limitFileSize: 5,
                validations: {
                    required: false
                },
                columnSize: 12
            }           
        ],
        ...paths,
        ...labels
    }
    
    return (
        <div>
            <CustomFormContainer 
                form = {form} 
                content    = {<CustomForm form={form} />}
            />
        </div>
    );
}
export default Form;
